const centersData = [
  { city: "Visakhapatnam", rating: 4.8, machines: 2, experts: 18, utilised: 78 },
  { city: "Vijayawada", rating: 4.7, machines: 2, experts: 14, utilised: 71 },
  { city: "Tirupati", rating: 4.6, machines: 1, experts: 12, utilised: 65 },
  { city: "Kurnool", rating: 4.5, machines: 1, experts: 9, utilised: 58 },
];

export default centersData;